import env from '@beam-australia/react-env';
import {
  getAttr,
  hasAttr,
} from '../../../../../../features/helpers/apiHelpers';

export const getCommentDeclineInfo = (commentDeclineInfo) => {
  const includeDecliner = env('EXT_SHOW_DECLINER') === 'true';

  return {
    commentDeclineReason: hasAttr(commentDeclineInfo, 'declineReason')
      ? getAttr(commentDeclineInfo, 'declineReason')
      : '',
    commentDecliner: includeDecliner
      ? getAttr(commentDeclineInfo, 'declinerInitials') ?? ''
      : null,
  };
};
